import React from 'react';
import { Grid } from '@material-ui/core';
import { TextBoxShrink } from '../../../../Core/FormInput';
import { get } from 'lodash';

export const RentalFleetDetails = React.memo((props) => {
    const { state, setState } = props;
    const setField = (e) => {
        const { name, type, value, valueAsNumber, checked } = e.target;
        if (type === 'number') {
            setState((st) => ({ ...st, [name]: valueAsNumber }));
        } else if (type === 'checkbox') {
            setState((st) => ({ ...st, [name]: checked }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };
    const getField = (name) => {
        return get(state, name);
    };
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextBoxShrink onChange={setField} value={getField('service24RentalCompany')} label="Company" name="service24RentalCompany" />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextBoxShrink onChange={setField} value={getField('service24RentalPhone')} label="Tel No" name="service24RentalPhone" />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextBoxShrink onChange={setField} value={getField('service24RentalContactName')} label="Contact Name" name="service24RentalContactName" />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextBoxShrink onChange={setField} value={getField('service24RentalOrderNo')} label="Order No" name="service24RentalOrderNo" />
            </Grid>
        </Grid>
    );
});
